import { useState, useRef, useEffect } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { updateAffiliate, getUserInfo } from "../../../api/User";
import { toast } from "react-toastify";

export default function AffiliateSection() {
    const [affiliateCode, setAffiliateCode] = useState("");
    const [existingAffiliate, setExistingAffiliate] = useState("");
    const [loading, setLoading] = useState(false);
    const [scanning, setScanning] = useState(false);
    const scannerRef = useRef<Html5Qrcode | null>(null);
    const scannerContainerId = "qr-reader-affiliate";

    useEffect(() => {
        const fetchAffiliate = async () => {
            const data = await getUserInfo();
            if (data?.info?.affiliate_sale) {
                setExistingAffiliate(data.info.affiliate_sale);
            }
        };
        fetchAffiliate();
        return () => {
            if (scannerRef.current?.isScanning) {
                scannerRef.current.stop().catch(() => {});
            }
        };
    }, []);

    const startScanner = async () => {
        setScanning(true);
    };

    const initScanner = async () => {
        try {
            const html5QrCode = new Html5Qrcode(scannerContainerId);
            scannerRef.current = html5QrCode;

            await html5QrCode.start(
                { facingMode: "environment" },
                { fps: 10, qrbox: { width: 250, height: 250 } },
                (decodedText) => {
                    setAffiliateCode(decodedText);
                    html5QrCode.stop().then(() => {
                        setScanning(false);
                    }).catch(() => {
                        setScanning(false);
                    });
                },
                () => {}
            );
        } catch (err) {
            console.error("QR scanner error:", err);
            toast.error("Không thể mở camera. Vui lòng kiểm tra quyền truy cập camera.");
            setScanning(false);
        }
    };

    useEffect(() => {
        if (scanning) {
            // Wait for modal DOM to render before initializing scanner
            const timer = setTimeout(() => initScanner(), 100);
            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scanning]);

    const stopScanner = async () => {
        if (scannerRef.current?.isScanning) {
            await scannerRef.current.stop();
        }
        setScanning(false);
    };

    const handleUpdate = async () => {
        if (!affiliateCode.trim()) {
            toast.error("Vui lòng nhập mã giới thiệu.");
            return;
        }
        setLoading(true);
        try {
            const resp = await updateAffiliate(affiliateCode.trim());
            if (resp.status) {
                toast.success("Cập nhật mã giới thiệu thành công.");
                setExistingAffiliate(affiliateCode.trim());
                setAffiliateCode("");
            } else {
                toast.error(resp.msg || "Cập nhật mã giới thiệu thất bại.");
            }
        } catch {
            toast.error("Có lỗi xảy ra, vui lòng thử lại.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            textAlign: "center",
            paddingTop: 0,
        }}>
            <p style={{
                fontSize: 16,
                fontWeight: 600,
                color: "#333",
                marginBottom: 20,
                fontFamily: "googlesansmedium",
            }}>
                Mã giới thiệu
            </p>

            {existingAffiliate ? (
                <>
                <div className="MuiFormControl-root MuiTextField-root jss35">
                    <label
                        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled Mui-disabled MuiFormLabel-filled"
                        htmlFor="affiliate_sale"
                    >
                        Mã giới thiệu
                    </label>
                    <div className="MuiInputBase-root MuiFilledInput-root jss36 Mui-disabled MuiInputBase-formControl">
                        <input
                            id="affiliate_sale"
                            type="text"
                            disabled
                            className="MuiInputBase-input MuiFilledInput-input Mui-disabled"
                            value={existingAffiliate}
                        />
                    </div>
                </div>
                <div
                    className="MuiPaper-root MuiAlert-root MuiAlert-standardInfo MuiPaper-elevation0"
                    role="alert"
                    style={{
                        width: "100%",
                        borderRadius: "8px",
                        display: "inline-flex",
                        justifyContent: "flex-start",
                        marginTop: 12,
                    }}
                >
                    <div className="MuiAlert-icon">
                        <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
                        </svg>
                    </div>
                    <div className="MuiAlert-message">
                        <p
                            className="MuiTypography-root MuiTypography-body1"
                            style={{ fontSize: "12px", padding: 0, textAlign: "left" }}
                        >
                            Tài khoản đã được gắn mã giới thiệu. Nếu muốn thay đổi, vui lòng liên hệ quản trị viên.
                        </p>
                    </div>
                </div>
                </>
            ) : (
                <>
            <div className="MuiFormControl-root MuiTextField-root jss35" style={{ position: "relative" }}>
                <label
                    className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled MuiFormLabel-filled"
                    htmlFor="affiliate_sale"
                >
                    Mã giới thiệu
                </label>
                <div className="MuiInputBase-root MuiFilledInput-root jss36 MuiInputBase-formControl" style={{ position: "relative" }}>
                    <input
                        id="affiliate_sale"
                        type="text"
                        placeholder="Nhập hoặc quét QR để lấy mã"
                        className="MuiInputBase-input MuiFilledInput-input"
                        style={{ paddingRight: 48 }}
                        value={affiliateCode}
                        onChange={(e) => setAffiliateCode(e.target.value)}
                    />
                    <button
                        type="button"
                        onClick={startScanner}
                        title="Quét mã QR"
                        style={{
                            position: "absolute",
                            right: 8,
                            top: "50%",
                            transform: "translateY(-50%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 36,
                            height: 36,
                            border: "none",
                            borderRadius: 6,
                            background: "transparent",
                            cursor: "pointer",
                            padding: 4,
                            transition: "background 0.2s",
                        }}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="#555">
                            <path d="M9.5 6.5v3h-3v-3h3M11 5H5v6h6V5zm-1.5 9.5v3h-3v-3h3M11 13H5v6h6v-6zm6.5-6.5v3h-3v-3h3M19 5h-6v6h6V5zm-6 8h1.5v1.5H13V13zm1.5 1.5H16V16h-1.5v-1.5zM16 13h1.5v1.5H16V13zm-3 3h1.5v1.5H13V16zm1.5 1.5H16V19h-1.5v-1.5zM16 16h1.5v1.5H16V16zm1.5-1.5H19V16h-1.5v-1.5zm0 3H19V19h-1.5v-1.5zM22 7h-2V4h-3V2h5v5zm0 15v-5h-2v3h-3v2h5zM2 22h5v-2H4v-3H2v5zM2 2v5h2V4h3V2H2z" />
                        </svg>
                    </button>
                </div>
            </div>

            {/* QR Scanner Modal */}
            {scanning && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        zIndex: 1300,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <div
                        onClick={stopScanner}
                        style={{
                            position: "absolute",
                            inset: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.6)",
                        }}
                    />
                    <div
                        style={{
                            position: "relative",
                            background: "#fff",
                            borderRadius: 12,
                            padding: 20,
                            width: "90%",
                            maxWidth: 400,
                            zIndex: 1,
                        }}
                    >
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 16,
                        }}>
                            <p style={{
                                fontSize: 16,
                                fontWeight: 600,
                                color: "#333",
                                margin: 0,
                            }}>
                                Quét mã QR
                            </p>
                            <button
                                type="button"
                                onClick={stopScanner}
                                style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    padding: 4,
                                    display: "flex",
                                }}
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="#666">
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                            </button>
                        </div>
                        <div
                            id={scannerContainerId}
                            style={{
                                borderRadius: 8,
                                overflow: "hidden",
                                border: "2px solid #428c04",
                            }}
                        />
                        <p style={{
                            fontSize: 13,
                            color: "#777",
                            marginTop: 12,
                            marginBottom: 0,
                            textAlign: "center",
                        }}>
                            Hướng camera vào mã QR để quét
                        </p>
                    </div>
                </div>
            )}

            <div style={{ margin: "20px 0px" }}>
                <button
                    className="MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 iQEreR my-order__button my-order__button--green bg-gradient"
                    type="button"
                    onClick={handleUpdate}
                    disabled={loading}
                    style={loading ? { opacity: 0.7, cursor: "not-allowed" } : {}}
                >
                    <span className="MuiButton-label">
                        {loading ? "Đang xử lý..." : "Cập nhật mã"}
                    </span>
                    <span className="MuiTouchRipple-root" />
                </button>
            </div>
                </>
            )}
        </div>
    );
}
